import * as d3 from 'd3';
import { Dimensions } from './dimensions';
import { Margins } from './margins';
import { ChartDimensions, ChartMargins, Chart as TChart } from '/src/lib/types';

/**
 * Chart
 */

export type ChartProps = TChart;

export class Chart implements ChartProps {
  parent: HTMLElement;
  element: any; // d3 element
  dimensions: ChartDimensions;
  name = '';
  render = true;
  margins: ChartMargins = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    xAxis: 0,
    yAxis: 0,
  };
  [key: string]: any;

  constructor(parent: HTMLElement, dimensions: Dimensions, name: string, margins?: Margins, render = true) {
    this.parent = parent;
    this.dimensions = dimensions;
    this.name = name;
    if (margins) this.margins = margins;
    if (typeof render === 'boolean') this.render = render;

    // Create SVG element and assign properties
    this.element = d3
      .select(this.parent)
      .append('svg')
      .attr('class', this.name ? this.name + '-svg' : 'chart-svg')
      .attr('width', this.dimensions.width + this.margins.left + this.margins.right)
      .attr('height', this.dimensions.height + this.margins.top + this.margins.bottom)
      .append('g');

    if (this.margins) this.element.attr('transform', 'translate(' + this.margins.left + ',' + this.margins.top + ')');

    return this.element;
  }

  get = (variable: string) => this[variable];

  set = (variable: string, value: any) => {
    if (!variable || !this[variable] || !value) return;
    this[variable] = value;
    return this[variable];
  };

  destroy = () => {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  };

  addChild = (child: HTMLElement) => {
    if (this.element && child) return this.element.appendChild(child);
  };

  removeChild = (child: HTMLElement) => {
    if (this.element && child) return this.element.removeChild(child);
  };
}
